import React, { useEffect, useState } from 'react';
import axios from 'axios';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
//import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import * as XLSX from 'sheetjs-style';

const MonthlyReport = () => {
  const [organizations, setOrganizations] = useState([]);
  const [selectedOrg, setSelectedOrg] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportData, setReportData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    axios.get('https://api.eazyworldehsengineering.com/api/organization_details')
      .then(res => {
        setOrganizations(res.data);
      })
      .catch(err => console.error('Error fetching organizations:', err));
  }, []);

  const handleFetchReport = async () => {
    if (!selectedOrg || !fromDate || !toDate) {
      alert('All fields are required.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await axios.get(`https://api.eazyworldehsengineering.com/api/candidate_registration/report/monthly_report`, {
        params: {
          organization: selectedOrg,
          from_date: fromDate,
          to_date: toDate,
        },
      });

      // const reportData = response.data.data;
      // handleDownloadExcel(reportData, fromDate, toDate); // <-- Pass data directly

      const data = response.data.data;
      setReportData(data);

    } catch (error) {
      console.error('Error fetching report data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleDownloadPDF = () => {
  //   const doc = new jsPDF('l');
  //   doc.setFontSize(14);
  //   doc.text('Monthly Report', 40, 30);
  //   doc.setFontSize(10);
  //   doc.text(`Organization: ${selectedOrg}`, 40, 45);
  //   doc.text(`From: ${fromDate} To: ${toDate}`, 40, 60);

  //   autoTable(doc, {
  //     startY: 70,
  //     head: [[
  //       'S No', 'Contractor No', 'Organisation Name', 'Name of Participant', 'Designation',
  //       'Topic', 'Batch No', 'Roll No', 'Training Date', 'Valid Up to',
  //       'Work Location', 'Incharge', 'Evaluation Status', 'Pass/Fail', 'Certificate Status'
  //     ]],
  //     body: reportData.map((row, idx) => [
  //       idx + 1,
  //       row.contract_number,
  //       row.organization,
  //       row.Name,
  //       row.designation,
  //       row.training_title,
  //       row.batch_no,
  //       row.sr_no,
  //       new Date(row.training_date).toLocaleDateString(),
  //       row.valid_upto,
  //       row.work_location,
  //       row.incharge,
  //       row.evaluation_status,
  //       row.pass_or_fail,
  //       row.certificate_status
  //     ]),
  //     styles: { fontSize: 7, cellPadding: 2 },
  //     headStyles: { fillColor: [51, 204, 0] },
  //   });

  //   doc.save('MonthlyReport.pdf');
  // };

  const handleDownloadPDF = () => {

    if (!selectedOrg || !fromDate || !toDate) {
      alert('Please select Organization and Date Range');
      return;
    }

    const url =
      `https://api.eazyworldehsengineering.com/api/candidate_registration/report/monthly_report/pdf` +
      `?organization=${encodeURIComponent(selectedOrg)}` +
      `&from_date=${fromDate}` +
      `&to_date=${toDate}`;

    window.open(url, '_blank');
  };

  const handleDownloadExcels = (reportData, fromDate, toDate) => {
    const fileName = `Monthly_Report_From_${fromDate}_To_${toDate}.xlsx`;

    const headers = [
      "S No", "Contractor No", "Contractor Name", "Aadhaar No", "Organisation Name", "Name of Participant", "Designation",
      "Topic", "Batch No", "Roll No", "Training Date", "Valid Up to",
      "Work Location", "Incharge", "Evaluation Status", "Pass/Fail", "Certificate Status (Issued /Not Issued)"
    ];

    const data = reportData.map((row, index) => [
      index + 1,
      row.contract_number || "",
      row.contract_name || "",
      row.aadhaar_no || "",
      row.organization || "",
      row.Name || "",
      row.designation || "",
      row.training_title || "",
      row.batch_no || "",
      row.sr_no || "",
      row.training_date ? new Date(row.training_date).toLocaleDateString('en-GB') : "",
      row.valid_upto ? new Date(row.valid_upto).toLocaleDateString('en-GB') : "",
      row.work_location || "",
      row.incharge || "",
      row.evaluation_status || "",
      row.pass_fail || "",
      row.certificate_status || "",
    ]);

    // Create worksheet data with proper structure
    const worksheetData = [
      ["Monthly Report"], // Title row
      [`From: ${fromDate.split('-').reverse().join('-')} To: ${toDate.split('-').reverse().join('-')}`], // Date row
      [], // Empty row
      headers, // Header row
      ...data // Data rows
    ];

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Set proper merge ranges
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }, // Title row merge
      { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } }, // Date row merge
    ];

    // Get the range of the worksheet
    const range = XLSX.utils.decode_range(ws["!ref"]);

    // Apply styles to all cells
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[cellAddress];
        if (!cell) continue;

        // Default style for all cells
        let style = {
          font: { sz: 11, color: { rgb: "000000" } },
          alignment: { vertical: "center", horizontal: "center", wrapText: true },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          },
        };

        // Title row (Row 0): "Monthly Report"
        if (R === 0) {
          style.font = { bold: true, sz: 18, color: { rgb: "000000" } };
          style.alignment = { horizontal: "center", vertical: "center" };
          style.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          };
        }
        // Date row (Row 1): "From: ... To: ..."
        else if (R === 1) {
          style.font = { bold: false, sz: 13, color: { rgb: "000000" } };
          style.alignment = { horizontal: "center", vertical: "center" };
          style.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          };
        }
        // Empty row (Row 2)
        else if (R === 2) {
          style.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          };
        }
        // Header row (Row 3): Column headers with bright green background
        else if (R === 3) {
          style.font = { bold: true, color: { rgb: "000000" }, sz: 10 }; // Black text, smaller size
          style.fill = { fgColor: { rgb: "33CC00" } }; // Bright green background
          style.alignment = { horizontal: "center", vertical: "center", wrapText: true };
          style.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          };
        }
        // Data rows (Row 4 onwards)
        else {
          // Different alignment for specific columns based on PHP code
          if (C === 0) { // S No - center
            style.alignment = { horizontal: "center", vertical: "center" };
          } else if (C === 6 || C === 7) { // Batch No, Roll No - center
            style.alignment = { horizontal: "center", vertical: "center" };
          } else if (C === 8 || C === 9) { // Training Date, Valid Up to - center
            style.alignment = { horizontal: "center", vertical: "center" };
          } else if (C === 3 || C === 5 || C === 12 || C === 14) { // Name, Topic, Evaluation Status, Certificate Status - center
            style.alignment = { horizontal: "center", vertical: "center" };
          } else { // Other columns - left aligned
            style.alignment = { horizontal: "left", vertical: "center" };
          }

          style.font = { sz: 10, color: { rgb: "000000" } }; // Smaller font for data
          style.border = {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } },
          };
        }

        cell.s = style;
      }
    }

    // Set column widths to show full data values
    ws["!cols"] = [
      { wch: 6 },   // S No
      { wch: 14 },  // Contractor No
      { wch: 20 },  // Contractor Name
      { wch: 20 },  // Aadhaar No
      { wch: 35 },  // Organisation Name - increased to show full name
      { wch: 18 },  // Name of Participant - increased
      { wch: 18 },  // Designation - increased
      { wch: 35 },  // Topic - increased for full topic names
      { wch: 10 },  // Batch No
      { wch: 12 },  // Roll No - increased
      { wch: 12 },  // Training Date
      { wch: 12 },  // Valid Up to
      { wch: 18 },  // Work Location - increased
      { wch: 12 },  // Incharge
      { wch: 25 },  // Evaluation Status - increased
      { wch: 10 },  // Pass/Fail
      { wch: 20 },  // Certificate Status
    ];

    // Set row heights - reduced header height for less spacing
    ws["!rows"] = [
      { hpt: 25 }, // Title row
      { hpt: 20 }, // Date row
      { hpt: 10 }, // Empty row - reduced
      { hpt: 25 }, // Header row - reduced from 35 to 25
      // Data rows will use default height
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Monthly Report");

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });

    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(dataBlob, fileName);
  };

  const handleDownloadExcel = (reportData, fromDate, toDate) => {
    const fileName = `Monthly_Report_From_${fromDate}_To_${toDate}.xlsx`;

    // Desired header order (as requested)
    const headers = [
      "S No",
      "Contractor No",
      "Organisation Name",
      "Name of Participant",
      "Designation",
      "Topic",
      "Batch No",
      "Roll No",
      "Aadhaar No",
      "Training Date",
      "Valid Up to",
      "Work Location",
      "Contractor Name",
      "Incharge",
      "Evaluation Status",
      "Pass/Fail",
      "Certificate Status (Issued /Not Issued)",
      //"Photo"
    ];

    // Map header -> column width (wch). Keep your previously chosen widths by header name.
    const colWidthByHeader = {
      "S No": 6,
      "Contractor No": 14,
      "Organisation Name": 35,
      "Name of Participant": 18,
      "Designation": 18,
      "Topic": 35,
      "Batch No": 10,
      "Roll No": 12,
      "Aadhaar No": 20,
      "Training Date": 12,
      "Valid Up to": 12,
      "Work Location": 18,
      "Contractor Name": 20,
      "Incharge": 12,
      "Evaluation Status": 25,
      "Pass/Fail": 10,
      "Certificate Status (Issued /Not Issued)": 20,
      //"Photo": 20
    };

    // Helper: map one data object to an array that follows the `headers` order.
    const mapRowToOrderedArray = (row, index) => {
      return headers.map(hdr => {
        switch (hdr) {
          case "S No": return index + 1;
          case "Contractor No": return row.contract_number || "";
          case "Organisation Name": return row.organization || "";
          case "Name of Participant": return row.Name || "";
          case "Designation": return row.designation || "";
          case "Topic": return row.training_title || "";
          case "Batch No": return row.batch_no || "";
          case "Roll No": return row.sr_no || "";
          case "Aadhaar No": return row.aadhaar_no || "";
          case "Training Date": return row.training_date ? new Date(row.training_date).toLocaleDateString('en-GB') : "";
          case "Valid Up to": return row.valid_upto ? new Date(row.valid_upto).toLocaleDateString('en-GB') : "";
          case "Work Location": return row.work_location || "";
          case "Contractor Name": return row.contract_name || "";
          case "Incharge": return row.incharge || "";
          case "Evaluation Status": return row.evaluation_status || "";
          case "Pass/Fail": return row.pass_fail || "";
          case "Certificate Status (Issued /Not Issued)": return row.certificate_status || "";
          //case "Photo": return row.passport_size || row.id_card || ""; // prefer passport_size, fallback to id_card
          default: return "";
        }
      });
    };

    // Build worksheet data (title, date row, header row, data rows)
    const titleRow = ["Monthly Report"];
    const dateRow = [`From: ${fromDate.split('-').reverse().join('-')} To: ${toDate.split('-').reverse().join('-')}`];
    const dataRows = reportData.map((r, i) => mapRowToOrderedArray(r, i));
    const wsData = [
      titleRow,
      dateRow,
      [],
      headers,
      ...dataRows
    ];

    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Merge title & date rows across full header width
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: headers.length - 1 } },
    ];

    // set column widths using header mapping (preserves widths even if order changes)
    ws["!cols"] = headers.map(hdr => ({ wch: colWidthByHeader[hdr] || 15 }));

    // Apply basic styles (reuse your styling logic but simpler here).
    // You may copy/paste your existing style loop if you want identical styles.
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const addr = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[addr];
        if (!cell) continue;

        // default cell style
        cell.s = {
          font: { sz: 10, color: { rgb: "000000" } },
          alignment: { vertical: "center", horizontal: "left", wrapText: true },
          border: {
            top: { style: "thin", color: { rgb: "000000" } },
            bottom: { style: "thin", color: { rgb: "000000" } },
            left: { style: "thin", color: { rgb: "000000" } },
            right: { style: "thin", color: { rgb: "000000" } }
          }
        };

        // Title row style
        if (R === 0) {
          cell.s.font = { bold: true, sz: 18, color: { rgb: "000000" } };
          cell.s.alignment = { horizontal: "center", vertical: "center" };
        } else if (R === 1) { // date row
          cell.s.font = { sz: 13, color: { rgb: "000000" } };
          cell.s.alignment = { horizontal: "center", vertical: "center" };
        } else if (R === 3) { // header row
          cell.s.font = { bold: true, sz: 10, color: { rgb: "000000" } };
          cell.s.fill = { fgColor: { rgb: "33CC00" } };
          cell.s.alignment = { horizontal: "center", vertical: "center", wrapText: true };
        } else { // data rows: tweak alignment for some columns if needed
          const headerForThisCol = headers[C]; // because headers line up with columns
          if (["S No", "Batch No", "Roll No", "Training Date", "Valid Up to", "Pass/Fail"].includes(headerForThisCol)) {
            cell.s.alignment = { horizontal: "center", vertical: "center" };
          } else if (["Name of Participant", "Topic", "Evaluation Status", "Certificate Status (Issued /Not Issued)", "Photo"].includes(headerForThisCol)) {
            cell.s.alignment = { horizontal: "center", vertical: "center" };
          } else {
            cell.s.alignment = { horizontal: "left", vertical: "center", wrapText: true };
          }
        }
      }
    }

    // Turn the Photo column cells into clickable hyperlinks if they contain URLs
    // Photo column index:
    const photoColIndex = headers.indexOf("Photo");
    if (photoColIndex !== -1) {
      const firstDataRowIndex = 4; // 0:title,1:date,2:empty,3:headers, so data begins at row 4 (0-based)
      for (let r = 0; r < reportData.length; r++) {
        const R = firstDataRowIndex + r;
        const C = photoColIndex;
        const addr = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[addr];
        const photoUrl = reportData[r].passport_size || reportData[r].id_card || "";
        if (photoUrl) {
          // Put a clickable text and hyperlink
          // Set display text "View Photo" and hyperlink target
          cell.v = "View Photo";
          cell.l = { Target: photoUrl, Tooltip: "Open photo" };
          // ensure it's treated as text
          cell.t = 's';
          // update style to center
          cell.s = cell.s || {};
          cell.s.alignment = { horizontal: "center", vertical: "center" };
        }
      }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Monthly Report");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array", cellStyles: true });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(dataBlob, fileName);
  };




  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <h1>Monthly Report</h1>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-primary card-outline">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4">
                  <label>Organization</label>
                  <select
                    className="form-control"
                    value={selectedOrg}
                    onChange={e => setSelectedOrg(e.target.value)}
                  >
                    <option value="">Select</option>
                    {organizations.map((org, idx) => (
                      <option key={idx} value={org.organ_name}>{org.organ_name}</option>
                    ))}
                  </select>
                </div>

                <div className="col-md-3">
                  <label>From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={e => setFromDate(e.target.value)}
                  />
                </div>

                <div className="col-md-3">
                  <label>To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={e => setToDate(e.target.value)}
                  />
                </div>

                <div className="col-md-2 d-flex align-items-end">
                  <button className="btn btn-primary w-100" onClick={handleFetchReport}>
                    View Report
                  </button>
                </div>
              </div>

              {isLoading && <p className="mt-3 text-muted">Loading report...</p>}

              {reportData.length > 0 && (
                <>
                  <div className="mt-4 text-right">
                    <button className="btn btn-sm btn-danger mr-2" onClick={handleDownloadPDF}>Download PDF</button>
                    {/* <button className="btn btn-sm btn-success" onClick={handleDownloadExcel}>Download Excel</button> */}
                    <button
                      className="btn btn-sm btn-success"
                      onClick={() =>
                        handleDownloadExcel(
                          reportData,
                          fromDate,
                          toDate
                        )
                      }
                    >
                      Download Excel
                    </button>
                  </div>

                  <div className="table-responsive mt-3">
                    <table className="table table-bordered table-sm table-striped">
                      <thead className="bg-secondary text-white">
                        <tr>
                          <th>S No</th>
                          <th>Contractor No</th>
                          <th>Organisation Name</th>
                          <th>Name</th>
                          <th>Designation</th>
                          <th>Topic</th>
                          <th>Batch No</th>
                          <th>Roll No</th>
                          <th>Training Date</th>
                          <th>Valid Up to</th>
                          <th>Work Location</th>
                          <th>Incharge</th>
                          <th>Evaluation Status</th>
                          <th>Pass/Fail</th>
                          <th>Certificate Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData.map((row, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{row.contract_number}</td>
                            <td>{row.organization}</td>
                            <td>{row.Name}</td>
                            <td>{row.designation}</td>
                            <td>{row.training_title}</td>
                            <td>{row.batch_no}</td>
                            <td>{row.sr_no}</td>
                            <td>{new Date(row.training_date).toLocaleDateString()}</td>
                            <td>{row.valid_upto}</td>
                            <td>{row.work_location}</td>
                            <td>{row.incharge}</td>
                            <td>{row.evaluation_status}</td>
                            <td>{row.pass_fail}</td>
                            <td>{row.certificate_status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MonthlyReport;
